import React from 'react';
import { Nav } from 'react-bootstrap';
import type { NavItemConfig } from './types';

interface NavItemProps {
  config: NavItemConfig;
  isActive: boolean;
}

export const NavItem: React.FC<NavItemProps> = ({ config, isActive }) => {
  if (!config.isVisible) {
    return null;
  }

  return (
    <Nav.Item>
      <Nav.Link
        href={config.href}
        onClick={config.onClick}
        className={`${isActive ? 'active' : 'inactive'} ${config.className || ''}`}
      >
        <img src={config.icon} alt={config.iconAlt} />
        {config.label}
        {config.badge && config.badge.count > 0 && (
          <div className={config.badge.className}>{config.badge.count}</div>
        )}
      </Nav.Link>
    </Nav.Item>
  );
};
